import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePrivacyStore = defineStore(
  'privacy',
  () => {
    const isActive = ref(false);

    function toggle() {
      isActive.value = !isActive.value;
    }

    function setActive(active: boolean) {
      isActive.value = active;
    }

    return {
      isActive,
      toggle,
      setActive,
    };
  },
  { persist: true },
);
